import { apiGetMissingAdddons } from "Root/api/apiProfile";
import toastService from "Root/profile/toastService";
import utils, { uuid } from "Root/profile/utils";
import { setMissingAddons, setOriginalMissingAddons } from "../../actionCreators/makeActionCreator";
const LoadMissingAddonsThunk = () => async (dispatch, getState) => {
    try {
        const state = getState();
        const { plan } = state.ordersInfo.nextOrderDates;
        const data = await apiGetMissingAdddons();
        const addons = data.addons.map((item) => {
            const count = plan === "advantage" && !utils.isAdditionalItem(item.product_key) ? 3 : 1;
            if (item.available_flavors) {
                const bagsCount = item.product_key === "protein" ? 1 : count;
                item.bags_info = [...Array(bagsCount)].map((bag) => ({
                    id: uuid(),
                    applyAll: false,
                    selected_flavors: item.available_flavors.map((flavor) => ({
                        short_name: flavor.short_name,
                        count: 0,
                    })),
                    attributes: item.attributes,
                    quantity: item.quantity,
                    sku: item.sku,
                }));
            }
            return {
                ...item,
                quantity: count,
            };
        });
        dispatch(setMissingAddons(addons));
        dispatch(setOriginalMissingAddons(JSON.parse(JSON.stringify(addons))));
    }
    catch (e) {
        toastService.errorMessage(e);
    }
};
export default LoadMissingAddonsThunk;
